import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { clsx } from 'clsx';
import { type ComponentPropsWithoutRef } from 'react';

import { useDialog } from '@repo/ui/Dialog/DialogRoot';

import s from './DialogContent.module.css';

export type DialogContentProps = ComponentPropsWithoutRef<'div'> & {
  as?: 'article' | 'div' | 'section';
  asChild?: boolean;
  className?: string;
};

export const dialogContentVariants = cva(s.content, {
  variants: {
    variant: {
      compact: s.compactVariant,
      standard: s.standardVariant,
    },
  },
});

export const DialogContent = (props: DialogContentProps) => {
  const { as = 'div', asChild, children, className, ...attrs } = props;
  const { variant } = useDialog();

  const Component = asChild ? Slot : as;

  return (
    <Component
      className={clsx(dialogContentVariants({ variant }), className)}
      {...attrs}
    >
      {children}
    </Component>
  );
};
